"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abs_csv_export_1 = __importDefault(require("./abs_csv_export"));
var account_object_1 = __importDefault(require("../../../common/src/utils/sales_force/account_object"));
var SalesForceAccountExport = /** @class */ (function (_super) {
    __extends(SalesForceAccountExport, _super);
    function SalesForceAccountExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesForceAccountExport.prototype.getCsvData = function (contractDocument, salesForceInfo) {
        return account_object_1.default.create(contractDocument, salesForceInfo);
    };
    SalesForceAccountExport.prototype.getFileName = function () {
        return 'Account.csv';
    };
    return SalesForceAccountExport;
}(abs_csv_export_1.default));
exports.default = SalesForceAccountExport;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/account_export.ts
// module id = jCvK
// module chunks = 1